import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StanState {
  stanDialogOpen: boolean;
  stanId: null | string;
  stanUrl: null | string;
  urls: Map<string, string>;
}

const initialState: StanState = {
  stanDialogOpen: false,
  stanId: null,
  stanUrl: null,
  urls: new Map(),
};

export const stanSlice = createSlice({
  name: "stan",
  initialState,
  reducers: {
    openStanDialog: (state, action: PayloadAction<string>) => {
      state.stanDialogOpen = true;
      state.stanId = action.payload;
      const url = state.urls.get(action.payload);
      if (url) state.stanUrl = url;
    },
    closeStanDialog: (state) => {
      state.stanDialogOpen = false;
      state.stanId = null;
      state.stanUrl = null;
    },
  },
});

export const { openStanDialog, closeStanDialog } = stanSlice.actions;

export default stanSlice.reducer;
